/*
Lehrgangssuche: klappt die Suchleiste unter der Topbar auf und zu.

Die Leiste liegt als Overlay ueber dem Hero; Auf- und Zufahren laeuft
ueber die Klasse .ist-offen (Transition in _topbar.scss). Ohne dieses
Skript bleibt die Lupe ein gewoehnlicher Link auf die Suchseite.
*/

jQuery(document).ready(function () {

	var $toggle = jQuery('.lehrgang-suche-toggle');
	var $leiste = jQuery('.lehrgang-suche-leiste');

	if (!$toggle.length || !$leiste.length) {
		return;
	}

	$toggle.attr('role', 'button').attr('aria-expanded', 'false');

	// Traegt die Klasse suche-offen, solange die Leiste offen ist --
	// darauf morpht der Bogen (.topbar-bogen) gerade, siehe _topbar.scss.
	var $wrapper = $leiste.closest('.navigation-wrapper');

	var schliessTimer = null;

	function leisteZu(fokusZurueck) {
		// Lag der Fokus im Suchfeld, faellt er beim Verstecken der Leiste auf
		// <body> und die Tastaturbedienung verliert ihre Position. Deshalb
		// zurueck auf die Lupe -- aber nur, wenn der Fokus wirklich innerhalb
		// der Leiste war, sonst reisst man ihn woanders weg.
		var fokusWarDrin = jQuery.contains($leiste[0], document.activeElement);

		$leiste.removeClass('ist-offen');
		$wrapper.removeClass('suche-offen');
		$toggle.attr('aria-expanded', 'false');

		// hidden erst nach der Transition (0.4s) -- mit kleinem Puffer,
		// damit das letzte Frame nie abgeschnitten wird.
		schliessTimer = window.setTimeout(function () {
			$leiste.prop('hidden', true);
		}, 450);

		if (fokusZurueck && fokusWarDrin) {
			$toggle.trigger('focus');
		}
	}

	function leisteAuf() {
		window.clearTimeout(schliessTimer);
		$leiste.prop('hidden', false);

		// Erzwungener Reflow: ohne ihn wuerden hidden-Entfernen und .ist-offen
		// im selben Frame landen und die Transition entfiele.
		void $leiste[0].offsetHeight;

		$leiste.addClass('ist-offen');
		$wrapper.addClass('suche-offen');
		$toggle.attr('aria-expanded', 'true');
		$leiste.find('input[name="q"]').trigger('focus');
	}

	$toggle.on('click', function (event) {
		event.preventDefault();

		if ($leiste.hasClass('ist-offen')) {
			leisteZu(false);
		} else {
			leisteAuf();
		}
	});

	jQuery(document).on('keyup', function (event) {
		if (event.key === 'Escape' && $leiste.hasClass('ist-offen')) {
			leisteZu(true);
		}
	});

	// Klick irgendwo anders auf der Seite schliesst die Leiste.
	jQuery(document).on('click', function (event) {
		if (!$leiste.hasClass('ist-offen')) {
			return;
		}

		if (jQuery(event.target).closest('.lehrgang-suche-leiste, .lehrgang-suche-toggle').length) {
			return;
		}

		leisteZu(false);
	});

});
